<template>
  <section v-if="isVisible" class="referral-inline" :class="{ compact }">
    <span class="referral-text">{{ $t('subscription.referral.inlineText') }}</span>
    <button class="referral-link-button" type="button" @click="handleOpenPopup">
      {{ $t('subscription.referral.inviteButton') }}
    </button>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { getCurrentUserStore } from '../../store/services';
import { getVueEnv } from '../../infrastructure/vue-env';
import { getInviteLinksFromApi } from '../../referrals/invite-links';
import { ReferralInvitePopupViewModel } from '../popup-view-models/referral-invite-popup.view-model';

interface Props {
  readonly compact?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  compact: false,
});

const { t } = useI18n();
const env = getVueEnv();
const userStore = getCurrentUserStore();
const isVisible = computed((): boolean => Boolean(userStore.getCurrentUserId()));

async function handleOpenPopup(): Promise<void> {
  if (!userStore.getCurrentUserId()) {
    return;
  }

  try {
    const links = await getInviteLinksFromApi();
    await env.popupService.showPopup(new ReferralInvitePopupViewModel(
      t('subscription.referral.popupTitle'),
      t('subscription.referral.webLabel'),
      links.webInviteLink,
      t('subscription.referral.telegramLabel'),
      links.telegramInviteLink,
      t('subscription.referral.shareButton'),
      t('subscription.referral.copyButton'),
      t('subscription.referral.closeButton'),
    ));
  } catch (error) {
    const message = error instanceof Error ? error.message : 'Failed to load invite link.';
    env.showAlert(message);
  }
}
</script>

<style scoped>
.referral-inline {
  margin-top: 18px;
  color: #4f6b91;
  line-height: 1.5;
  text-align: center;
}

.referral-inline.compact {
  margin-top: 14px;
}

.referral-link-button {
  border: none;
  background: transparent;
  color: #183153;
  cursor: pointer;
  padding: 0;
  margin-left: 6px;
  font-size: inherit;
  text-decoration: underline;
}

.referral-link-button:hover {
  color: #0f2744;
}
</style>
